import React, { useState } from 'react';
import './Download.css';

const appFiles = [
  { name: 'AuditRack Mobile App', path: '/Download/Mobile_app/AuditRack.apk', type: 'Android' },
  { name: 'Auditusierp Mobile App', path: '/Download/Mobile_app/AuditusIerp-Mobileapp.apk', type: 'Android' }
];

const appInstructions = [
  '1. Click the Download button for your desired app.',
  '2. If prompted, allow downloads from this source in your browser.',
  '3. Once downloaded, open the APK file.',
  '4. If asked, enable installation from unknown sources in your device settings.',
  '5. Follow the on-screen instructions to complete installation.'
];

const files = [
  { name: 'Auditusierp18.5.5.9.rar', size: '56,160 KB', date: '2024/06/26 7:33 AM', path: '/Download/Downloads/Auditusierp18.5.5.9.rar' },
  { name: 'AuditusierReportTool 18.5.5.9.rar', size: '56,110 KB', date: '2023/11/01 7:17 AM', path: '/Download/Downloads/AuditusierReportTool 18.5.5.9.rar' },
  { name: 'mysql 8.0.31.rar', size: '5,463 KB', date: '2023/08/27 3:18 PM', path: '/Download/Downloads/mysql 8.0.31.rar' },
];

const gstFiles = [
  { name: 'GSTR1.zip', size: '3,398 KB', date: '2023/10/27 6:57 AM', path: '/Download/GST/GSTR1.zip' },
  { name: 'GSTR2.zip', size: '1,135 KB', date: '2023/10/27 7:00 AM', path: '/Download/GST/GSTR2.zip' },
  { name: 'GSTR3B.zip', size: '76 KB', date: '2023/10/27 7:00 AM', path: '/Download/GST/GSTR3B.zip' },
  { name: 'GSTR4.zip', size: '6,931 KB', date: '2023/10/27 7:01 AM', path: '/Download/GST/GSTR4.zip' },
  { name: 'GSTRITC04.zip', size: '868 KB', date: '2023/10/27 7:01 AM', path: '/Download/GST/GSTRITC04.zip' }
];
const backupFiles = [
  { name: 'Automobiles shop demo.rar', size: '357 KB', date: '2023/11/26 8:39 AM', path: '/Download/Backup/Automobiles shop demo.rar' },
  { name: 'Computer and Hardware demo.rar', size: '150 KB', date: '2023/11/26 8:39 AM', path: '/Download/Backup/Computer and Hardware demo.rar' },
  { name: 'Footwear shop demo.rar', size: '131 KB', date: '2023/11/26 8:39 AM', path: '/Download/Backup/Footwear shop demo.rar' },
  { name: 'Mobile shop demo.rar', size: '51 KB', date: '2023/11/26 8:39 AM', path: '/Download/Backup/Mobile shop demo.rar' },
  { name: 'Pharma Agencies Demo.rar', size: '671 KB', date: '2023/11/26 8:39 AM', path: '/Download/Backup/Pharma Agencies Demo.rar' },
  { name: 'Pharmacyretail.rar', size: '771 KB', date: '2023/11/26 8:39 AM', path: '/Download/Backup/Pharmacyretail.rar' },
  { name: 'plywoodbackup.rar', size: '263 KB', date: '2023/11/26 8:38 AM', path: '/Download/Backup/plywoodbackup.rar' },
  { name: 'Sanitary shop demo.rar', size: '157 KB', date: '2023/11/26 8:38 AM', path: '/Download/Backup/Sanitary shop demo.rar' },
  { name: 'Supermarket.rar', size: '955 KB', date: '2023/11/26 8:19 AM', path: '/Download/Backup/Supermarket.rar' },
  { name: 'Textiles shop demo.rar', size: '266 KB', date: '2023/11/26 8:38 AM', path: '/Download/Backup/Textiles shop demo.rar' }
];



export default function Download() {
  const [selected, setSelected] = useState(null);
  const [showAppPopup, setShowAppPopup] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [activeTab, setActiveTab] = useState('download'); // 'download' or 'apps'

  const handleAppDownloadClick = (app) => {
    setSelectedApp(app);
    setShowAppPopup(true);
  };

  const handleAppPopupClose = () => {
    setShowAppPopup(false);
    setSelectedApp(null);
  };

  return (
    <div className="download-main-wrapper">
      {/* Tab Buttons */}
      <div style={{
        display: 'flex', justifyContent: 'center', gap: 12, marginBottom: 18
      }}>
        <button
          onClick={() => setActiveTab('download')}
          style={{
            background: activeTab === 'download' ? '#0a4f88' : '#e0e0e0',
            color: activeTab === 'download' ? '#fff' : '#0a4f88',
            border: 'none',
            borderRadius: 8,
            padding: '10px 18px',
            fontWeight: 700,
            fontSize: 18,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            cursor: 'pointer'
          }}
        >
          <i className="fab fa-windows" style={{ fontSize: 22 }}></i> Download
        </button>
        <button
          onClick={() => setActiveTab('apps')}
          style={{
            background: activeTab === 'apps' ? '#0a4f88' : '#e0e0e0',
            color: activeTab === 'apps' ? '#fff' : '#0a4f88',
            border: 'none',
            borderRadius: 8,
            padding: '10px 18px',
            fontWeight: 700,
            fontSize: 18,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            cursor: 'pointer'
          }}
        >
          <i className="fas fa-mobile-alt" style={{ fontSize: 22 }}></i> Download Apps
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'download' && (
        <section className="download-section">
          <h1 className="Download-heading">Downloads</h1>
          <div className="download-row">
            {files.map((file, i) => (
              <div
                key={i}
                className={`file-box${selected === i ? ' selected' : ''}`}
                title={`${file.name} • ${file.size} • ${file.date}`}
                onClick={() => setSelected(i)}
                tabIndex={0}
                style={{ outline: selected === i ? 'none' : undefined }}
              >
                <div className="file-name">{file.name}</div>
                <div className="file-info">
                  <span>{file.size}</span>
                </div>
              </div>
            ))}
          </div>
          <button
            className="download-button"
            disabled={selected === null}
            style={{ marginTop: 32, width: '100%' }}
            onClick={() => {
              if (selected !== null) {
                window.location.href = files[selected].path;
              }
            }}
          >
            {selected === null ? 'Select a file to Download' : `Download: ${files[selected].name}`}
          </button>
        </section>
      )}

      {activeTab === 'apps' && (
        <section className="download-section">
          <h1 className="Download-heading">Download App's</h1>
          <div className="download-row">
            {appFiles.map((app, i) => (
              <div
                key={i}
                className="file-box"
                title={app.name}
                tabIndex={0}
                onClick={() => handleAppDownloadClick(app)}
                style={{ cursor: 'pointer' }}
              >
                <div className="file-name">{app.name}</div>
                <div className="file-info">
                  <span>{app.type}</span>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {showAppPopup && (
        <div className="popup-overlay" onClick={handleAppPopupClose}>
          <div className="popup-content" onClick={e => e.stopPropagation()}>
            <h2>How to Download & Install</h2>
            <ul style={{ textAlign: 'left' }}>
              {appInstructions.map((inst, idx) => (
                <li key={idx}>{inst}</li>
              ))}
            </ul>
            <a
              href={selectedApp.path}
              download
              className="download-button"
              style={{ marginTop: 16, width: '100%' }}
            >
              Download: {selectedApp.name}
            </a>
            <button className="download-button" style={{ marginTop: 8, width: '100%' }} onClick={handleAppPopupClose}>
              Close
            </button>
          </div>
        </div>
      )}
      {/* Add minimal popup CSS if not present in Download.css */}
      {/* Font Awesome CDN for icons */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" />
      <style>{`
        .download-main-wrapper {
          margin-top: 80px;
        }
        @media (max-width: 900px) {
          .download-main-wrapper {
            margin-top: 90px;
          }
        }
        /* GST and Business Template boxes full width on mobile */
        @media (max-width: 900px) {
          .gst-file-item {
            width: 100% !important;
            min-width: 0;
            box-sizing: border-box;
          }
          .gst-file-list {
            padding: 0;
            margin: 0;
          }
          .backup-table {
            width: 100% !important;
            min-width: 0;
            box-sizing: border-box;
          }
          .backup-table tr {
            width: 100% !important;
            min-width: 0;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: flex-start;
          }
          .backup-table td {
            width: 100%;
            box-sizing: border-box;
          }
          .backup-table td:last-child {
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
          }
          .backup-download-link {
            width: 100%;
            margin: 0;
            align-self: flex-end;
          }
        }
        .popup-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .popup-content {
          background: #fff;
          padding: 24px 10px;
          border-radius: 8px;
          max-width: 340px;
          width: 98%;
          box-shadow: 0 2px 16px rgba(0,0,0,0.2);
          text-align: center;
        }
        .popup-content h2 {
          font-size: 1.1rem;
          margin-bottom: 12px;
        }
        .popup-content ul {
          font-size: 0.98rem;
        }
        @media (max-width: 600px) {
          .popup-content {
            max-width: 98vw;
            padding: 14px 2vw;
          }
          .popup-content h2 {
            font-size: 1rem;
          }
          .popup-content ul {
            font-size: 0.92rem;
          }
        }
      `}</style>

      {/* New GST Reports Section */}
      <section className="gst-download-section">
        <h1 className="gst-download-heading">GST Reports</h1>
        <ul className="gst-file-list">
          {gstFiles.map((file, i) => (
            <li key={i} className="gst-file-item" title={`${file.name} • ${file.size} • ${file.date}`}>
              <div className="gst-file-name">{file.name}</div>
              <div className="gst-file-info">
              </div>
              <a href={file.path} download className="gst-download-button">
                Download
              </a>
            </li>
          ))}
        </ul>
      </section>
      <section className="backup-section">
        <h1 className="backup-heading">Business Template Backup Files</h1>
        <table className="backup-table">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {backupFiles.map((file, i) => (
              <tr key={i} title={`${file.name} • ${file.size} • ${file.date}`}>
                <td>{file.name}</td>
                <td>
                  <a href={file.path} download className="backup-download-link">
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}